<template>
  <b-card class="mt-3">
    <div class="d-flex flex-wrap">
      <h4>Галерея на главной странице</h4>
      <b-button
        variant="primary"
        @click="onLoadFile"
        class="d-block ml-auto"
      >
        Добавить
      </b-button>
    </div>
    <div v-if="!noFiles">
      <ag-grid-vue
        class="ag-theme-material h-100"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :rowData="rowData"
      />
    </div>
    <h5 class="mt-4" v-else>
      В галереи нет изображений
    </h5>
    <b-form-file
      @change='loadFile($event.target)'
      plain
      hidden
      multiple
      accept="image/png, image/jpeg"
      ref="galleryFileInput"
    />
    <b-modal
      v-if="fileForDelete"
      size="lg"
      id="deleteGalleryFileModal"
      title="Удаление файла галереи"
      @ok="deleteFile"
    >
      <div>
        Вы уверены, что хотите убрать с главной страницы файл {{ fileForDelete.name }}
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button @click="ok()" variant="primary">
          Удалить
        </b-button>
        <b-button @click="cancel()"> Отмена </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import { mapActions } from 'vuex'
import GalleryAPI from '@/api/gallery'
import AgGridFactory from '@/components/helpers/factory/agGrid'

export default {
  name: 'GallerySettings',
  components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      noFiles: false,
      fileForDelete: null,
      rowData: [],
      gridOptions: AgGridFactory.getGridOptionsDefault({
        defaultColDef: {
          sortable: true,
          filter: false,
          headerClass: 'p-1',
          cellClass: 'p-1',
          resizable: true
        },
        domLayout: 'autoHeight',
        pagination: false
      }),
      columnDefs: [
        {
          headerName: 'Название',
          field: 'name'
        },
        AgGridFactory.getDefaultActionRenderer({
          onInfo: this.onInfo,
          infoTitle: 'Просмотр',
          onDelete: this.onDelete
        })
      ]
    }
  },
  async created() {
    await this.updateTable()
  },
  methods: {
    ...mapActions({
      pushToasts: 'toasts/pushToasts'
    }),
    onInfo(params) {
      window.open(`/api/files/${params.physicalName}`, '_blank')
    },
    onDelete(params) {
      this.fileForDelete = params
      this.$nextTick(() => {
        this.$bvModal.show('deleteGalleryFileModal')
      })
    },
    async deleteFile() {
      await GalleryAPI.deleteGalleryFile(this.fileForDelete.id)
      this.pushToasts({
        time: 3,
        title: 'Галерея',
        message: 'Файл успешно удален'
      })
      await this.updateTable()
    },
    async updateTable() {
      const response = await GalleryAPI.getGalleryFiles()
      this.rowData = response.data.files.map((f) => ({ ...f.file, id: f.id }))
      this.noFiles = !this.rowData.length
    },
    onLoadFile() {
      this.$refs.galleryFileInput.$refs.input.click()
    },
    async loadFile(input) {
      if (input.files && input.files.length) {
        await GalleryAPI.uploadGalleryFiles(input.files)
        this.pushToasts({
          time: 3,
          title: 'Галерея',
          message: 'Файлы успешно загружены'
        })
        await this.updateTable()
      }
      this.$refs.galleryFileInput.$refs.input.value = null
    }
  }
}
</script>

<style scoped lang="scss">
.text{
  color: rgba(0, 0,0, 0.5);
  font-style: italic;
}
.year{
  width: 5em;
}


</style>
